import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M7 17a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2H9a2 2 0 00-2 2v11zm-4-1a1 1 0 001 1h1V6H4a1 1 0 00-1 1v9zM19 6v11h1a1 1 0 001-1V7a1 1 0 00-1-1h-1z" }));
export default createSvgIcon(iconPath, "ViewCarousel");
//# sourceMappingURL=ViewCarouselIcon.js.map